/* =============================== *
 *  Tax price init - always with VAT
 * =============================== */
(() => {
  'use strict';

  const COOKIE_NAME = 'check_tax';
  const COOKIE_VALUE = 'with_tax';
  const LOADER_MAX_MS = 6000;

  function setWithTaxCookie() {
    const days = 365;
    const date = new Date();
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);

    document.cookie = `${COOKIE_NAME}=${COOKIE_VALUE}; expires=${date.toUTCString()}; path=/`;
  }

  function getCookieSetting(name) {
    const nameEQ = name + '=';
    const ca = document.cookie.split(';');

    for (let i = 0; i < ca.length; i++) {
      let c = ca[i];

      while (c.charAt(0) === ' ') {
        c = c.substring(1, c.length);
      }

      if (c.indexOf(nameEQ) === 0) {
        return c.substring(nameEQ.length, c.length);
      }
    }

    return null;
  }

  function hideTaxPopup() {
    const taxPopContainer = document.getElementById('tax-pop__container');

    if (taxPopContainer) {
      taxPopContainer.style.display = 'none';
      taxPopContainer.setAttribute('hidden', 'hidden');
    }
  }

  function hideTaxSwitcher() {
    const possibleSwitches = document.querySelectorAll(`
      input.tax-setting,
      #tax-toggle,
      .tax-setting,
      .tax-switch,
      .tax-toggle,
      .tax-selector,
      .tax-button,
      [data-tax-switch],
      [data-tax-toggle],
      [data-tax-selector]
    `);

    possibleSwitches.forEach((el) => {
      const wrapper =
        el.closest('.tax-switch') ||
        el.closest('.tax-toggle') ||
        el.closest('.tax-selector') ||
        el.closest('.header__tax') ||
        el.closest('.header-tax') ||
        el.closest('.switch') ||
        el.parentElement;

      if (wrapper) {
        wrapper.style.display = 'none';
        wrapper.setAttribute('hidden', 'hidden');
      } else {
        el.style.display = 'none';
        el.setAttribute('hidden', 'hidden');
      }
    });
  }

  function forceWithTaxPrices() {
    setWithTaxCookie();

    const withTaxNodes = document.querySelectorAll('span.price.price-with-tax');
    const noTaxNodes = document.querySelectorAll('span.price.price-no-tax');
    const priceLists = document.querySelectorAll('.price-list');

    withTaxNodes.forEach((el) => {
      el.classList.add('active');
    });

    noTaxNodes.forEach((el) => {
      el.classList.remove('active');
    });

    priceLists.forEach((el) => {
      el.style.flexDirection = 'column';
    });

    const toggleSwitches = document.querySelectorAll('input.tax-setting, #tax-toggle');

    toggleSwitches.forEach((toggle) => {
      toggle.checked = true;
      toggle.setAttribute('checked', 'checked');
    });
  }

  function removeLoader() {
    clearTimeout(window.__loaderWatchdog);

    const priceContainers = document.querySelectorAll('.price-list');
    const loaders = document.querySelectorAll('.loader');

    priceContainers.forEach((el) => {
      el.style.display = 'block';
    });

    loaders.forEach((el) => {
      el.style.display = 'none';
    });

    forceHideProductItemLoaders();
  }

  function startLoaderWatchdog(context = 'init') {
    clearTimeout(window.__loaderWatchdog);

    window.__loaderWatchdog = setTimeout(() => {
      forceHideProductItemLoaders();

      const visibleLoaders = [...document.querySelectorAll('.loader')].filter((el) => {
        return getComputedStyle(el).display !== 'none';
      });

      if (visibleLoaders.length) {
        console.log(`[tax] Watchdog fired (${context}). Force-hiding ${visibleLoaders.length} loader(s).`);
        removeLoader();
        forceWithTaxPrices();
      }
    }, LOADER_MAX_MS);
  }

  function isVisible(el) {
    if (!el) return false;

    const cs = getComputedStyle(el);

    return cs.display !== 'none' && cs.visibility !== 'hidden' && Number(cs.opacity) !== 0;
  }

  function forceHideProductItemLoaders() {
    document.querySelectorAll('.product-item').forEach((item) => {
      const loader = item.querySelector('.loader');

      if (isVisible(loader)) {
        loader.style.setProperty('display', 'none', 'important');

        const price = item.querySelector('.product-item__price-list.price-list, .price-list');

        if (price) {
          price.style.setProperty('display', 'inline-flex', 'important');
        }
      }
    });
  }

  function applyTaxUI() {
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        hideTaxPopup();
        hideTaxSwitcher();
        forceWithTaxPrices();
        removeLoader();
      });
    });
  }

  function initTaxFlow(context = 'init') {
    startLoaderWatchdog(context);

    const currentCookie = getCookieSetting(COOKIE_NAME);

    if (currentCookie !== COOKIE_VALUE) {
      setWithTaxCookie();
    }

    hideTaxPopup();
    hideTaxSwitcher();
    forceWithTaxPrices();
    removeLoader();
  }

  function wireBackLinkFromQuery() {
    const params = new URLSearchParams(window.location.search);
    const paginate = params.get('paginate');
    const parts = window.location.pathname.split('/').filter(Boolean);
    const collectionIdx = parts.indexOf('collections');
    const collectionHandle = collectionIdx > -1 ? parts[collectionIdx + 1] : null;

    if (collectionHandle && paginate) {
      const backLink = `/collections/${collectionHandle}?page=${paginate}`;
      const backEl = document.querySelector('.go-back-collection');

      if (backEl) {
        backEl.setAttribute('href', backLink);
      }
    }
  }

  function appendJsFilterTree() {
    const jsFilters = document.getElementById('gf-tree');
    const propFilter = document.querySelector('.gf-tree.prop');
    const bannerHead = document.querySelector('.collection');

    if (jsFilters && bannerHead) {
      bannerHead.appendChild(jsFilters);

      jsFilters.style.display = 'block';
      jsFilters.style.width = '20%';
      jsFilters.style.marginRight = '40px';
      jsFilters.style.minWidth = '20%';

      if (propFilter) {
        propFilter.style.display = 'none';
      }
    } else {
      if (propFilter) {
        propFilter.style.display = 'none';
      }
    }
  }

  function observeDynamicChanges() {
    if (window.__taxAlwaysWithVatObserver) {
      window.__taxAlwaysWithVatObserver.disconnect();
    }

    window.__taxAlwaysWithVatObserver = new MutationObserver(() => {
      applyTaxUI();
    });

    window.__taxAlwaysWithVatObserver.observe(document.body, {
      childList: true,
      subtree: true,
    });
  }

  document.addEventListener('variant:changed', function (event) {
    const variant = event.detail.variant;
    const propElement = document.getElementById('prop_sku');

    if (variant && propElement) {
      propElement.value = variant.sku;
    }

    applyTaxUI();
  });

  document.addEventListener('shopify:section:load', () => {
    initTaxFlow('section-load');
  });

  window.addEventListener('globoFilterRenderCompleted', () => {
    initTaxFlow('globo-filter');
  });

  window.addEventListener('pageshow', () => {
    initTaxFlow('pageshow');
  });

  document.addEventListener('DOMContentLoaded', () => {
    initTaxFlow('domcontentloaded');
    wireBackLinkFromQuery();
    observeDynamicChanges();
  });

  window.addEventListener('load', () => {
    initTaxFlow('window-load');
    appendJsFilterTree();
  });
})();